// Espejo JS de los design tokens de src/styles/tokens.css.
//
// ¿Por qué un espejo y no leer las CSS vars? Para inline styles de React, `var(--x)`
// funciona; pero para gráficos (canvas: Trends/charts) y cualquier lugar que necesite un
// valor de color REAL, `var(--x)` no sirve. Un espejo JS con los mismos valores es lo más
// simple de mantener (los colores casi no cambian) y funciona en todos los contextos.
// REGLA: si cambiás un valor acá, cambialo también en tokens.css (y viceversa).

export const BRAND = {
  primary:      '#7433E0',
  primaryHover: '#5F27C4',
  primaryLight: '#F0E9FC',
  onPrimary:    '#FFFFFF',
  // Componentes RGB del violeta (espejo de --color-brand-rgb) para alphas variables
  // en JS (heatmaps) y colores numéricos (jsPDF). String: primaryRgb.join(',').
  primaryRgb:   [116, 51, 224],
};

// Texto (espejo de --color-text-* de tokens.css) — para gráficos que necesitan el valor
// real (canvas/SVG de recharts), donde var(--x) no sirve.
export const TEXT = {
  secondary: '#8B869C',
  tertiary:  '#A89FB5',
};

// Estados (equivalentes hex de los OKLCH de tokens.css).
export const STATE = {
  success: { text: '#197a4c', bg: '#dcf5e6', solid: '#22c55e' },
  warning: { text: '#7a5a0e', bg: '#f5eecb', solid: '#f59e0b' },
  error:   { text: '#c0362b', bg: '#f8ddd6', solid: '#ef4444' },
  info:    { text: '#2e7fd6', bg: '#e4effb', solid: '#3b82f6' },
};

// Tipo de cuenta/caja (distinto del canal de venta).
export const ACCOUNT = {
  banco:     '#3f6fd6',
  nequi:     '#9b3bc9',
  daviplata: '#d15a3a',
};

// Estado "en espera" (on-hold) — 5º estado.
export const EN_ESPERA = { text: '#5b52c9', bg: '#e8e6f7' };
// Estado "reembolsado" (refunded) — 6º estado (púrpura).
export const REEMBOLSADO = { text: '#6d28d9', bg: '#f1e9fb' };

// Acentos de categoría puntuales.
export const HISTORICO_COMPRAS = '#3730a3';
export const MARKETING = { text: '#9d174d', bg: '#fdf2f8' };

// Acentos por canal.
export const CHANNEL = {
  ia:            '#7433E0',
  tiendaFisica:  '#16a39c', // turquesa
  web:           '#2e7fd6', // azul
  feria:         '#d95aa1', // rosa
  whatsapp:      '#d98a3d', // naranja
};
